import { create } from 'zustand';

interface UpdatePermission {
    updatedPermission: any[];
    setUpdatedPermission: (open: any[]) => void;
}

// Create the Zustand store with types
const useUpdatePermissionStore = create<UpdatePermission>((set) => ({
    updatedPermission: [],
    setUpdatedPermission: (open: any[]) => set({ updatedPermission: open }),
}));

export default useUpdatePermissionStore;
